import React from 'react';
import { LessonHomeworkIndexView } from '../../../types/lesson_homeworks';
import { observer } from 'mobx-react';
import { ReviewerAssignmentStatusSummary } from './ReviewerAssignmentStatusSummary';
import { V3Routes } from '../../../routes';
import { SimpleUserView } from '../../../types/users';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { DetailsButton } from '../../molecules/course_works/DetailsButton';
import './lessonHomeworkHeaderContent.module.scss';

type Props = {
  homework: LessonHomeworkIndexView;
  showReviewer: boolean;
  reviewer?: SimpleUserView | null;
};

// グレーページのヘッダーの中に表示させるLessonHomework用の中身
export const LessonHomeworkHeaderContent = observer(({ homework, reviewer = null, showReviewer }: Props) => {
  const { title, description, lesson, published_linked_section_ids, lesson_id, course_id } = homework;
  const { isSp } = useViewportState();
  return (
    <div styleName="content" id="lesson-homework-header">
      {lesson && <div styleName="day-label">LESSON {lesson.index + 1}</div>}
      <div styleName="title">{title}</div>
      {description && <pre styleName="description">{description}</pre>}
      <div styleName="bottom-tools">
        {showReviewer && (
          <ReviewerAssignmentStatusSummary id="reviewer-assignment-status-summary" key={1} reviewer={reviewer} />
        )}
        {published_linked_section_ids.length > 0 && (
          <DetailsButton
            isSp={isSp}
            to={V3Routes.courseSection(course_id, lesson_id, published_linked_section_ids[0])}
          />
        )}
      </div>
    </div>
  );
});
